import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { BadgeColor } from '../common/badge/badge.types';
import { IconName } from '../icons-container/icons.type';

@Component({
  selector: 'rt-new-item-button',
  templateUrl: 'new-item-button.component.html',
  styleUrls: ['./new-item-button.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewItemButtonComponent {
  @Input() public icon: IconName;
  @Input() public heading: string = '';
  @Input() public subheading: string = '';
  @Input() public badgeText?: string;
  @Input() public badgeVariant: BadgeColor;
}
